var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('PageHeader',{attrs:{"merchant":_vm.merchant}}),_vm._t("default"),_c('PageFooter',{attrs:{"company":_vm.company}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }